module.exports = __webpack_public_path__ + "static/img/icon_plus.eea1dc12.svg";